import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { useIntl } from "react-intl";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import ScrollToTop from "@Src_main/utils/scrollToTop";
import CreateAccountPage from "@Components/CreateAccountPage";
import { env } from "build/env";
var OrderPage = lazy(() => import("@Pages/OrderPage/order"));
var OrderPageFromRestaurant = lazy(() => import("@Pages/OrderPage/orderFromRestaurant"));
var LoginPage = lazy(() => import("@Pages/LoginPage/loginPage"));
var CheckoutNormalPage = lazy(() => import("../overrides/venia-ui/components/CheckoutPage/checkoutNormalPage"));
var EventsReservation = lazy(() => import("../pages/EventsReservation"));
var LoginFeedback = lazy(() => import("../pages/LoginFeedback"));
var PwdRecovery = lazy(() => import("../pages/PwdRecovery"));
var PreLogin = lazy(() => import("../pages/PreLogin"));
var MenuRistorante = lazy(() => import("../pages/MenuRistorante"));
var MenuTakeaway = lazy(() => import("../pages/MenuTakeaway"));
var BookTable = lazy(() => import("../pages/BookTable"));
var BookEvent = lazy(() => import("../pages/BookEvent"));
var FaqCategory = lazy(() => import("../pages/FaqCategory"));
var FaqDetail = lazy(() => import("../pages/FaqDetail"));
var Faq = lazy(() => import("../pages/Faq"));
var Stores = lazy(() => import("../pages/Stores"));
var ProduttoriDetail = lazy(() => import("../pages/ProduttoriDetail"));
var OurPath = lazy(() => import("../pages/OurPath"));
var MyAccount = lazy(() => import("../pages/MyAccount"));
var Reservations = lazy(() => import("../pages/Reservations"));
var Orders = lazy(() => import("../pages/OrderDetails"));
var MyAccountData = lazy(() => import("../pages/MyAccountData"));
var BlogDetail = lazy(() => import("../pages/BlogDetail"));
var SearchBlog = lazy(() => import("../pages/SearchPageBlog"));
var BlogCategory = lazy(() => import("../pages/BlogCategory"));
var CookieCheck = lazy(() => import("./../pages/CookiesCheck"));
var PuntiSeeds = lazy(() => import("../pages/PuntiSeeds"));
var EventDetails = lazy(() => import("../pages/EventDetails"));
var TablePage = lazy(() => import("../pages/TableStatus/TablePage"));
var ReceiptRoot = lazy(() => import("../pages/Receipt/ReceiptRoot"));
var MagentoRoute = lazy(() => import("../overrides/venia-ui/components/MagentoRoute"));
var CouponPage = lazy(() => import("../pages/CouponPage/couponPage"));
var ConvertTicketPage = lazy(() => import("../pages/ConvertTicket/convertTicket"));
var KioskLoginRoot = lazy(() => import("../pages/KioskLogin/KioskLoginRoot"));
var Routes = () => {
  var {
    formatMessage
  } = useIntl();
  var {
    IS_COUPON_ACTIVE
  } = env;
  var routeStructure = /*#__PURE__*/React.createElement(ScrollToTop, null, /*#__PURE__*/React.createElement(Switch, null, isOrderActive && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: MenuTakeaway
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.checkout"
    })
  }, /*#__PURE__*/React.createElement(CheckoutNormalPage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.restaurant.menu"
    })
  }, /*#__PURE__*/React.createElement(MenuRistorante, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.pre.login"
    })
  }, /*#__PURE__*/React.createElement(PreLogin, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.app.login"
    })
  }, /*#__PURE__*/React.createElement(PreLogin, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/login-feedback"
  }, /*#__PURE__*/React.createElement(LoginFeedback, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.book.a.table"
    })
  }, /*#__PURE__*/React.createElement(BookTable, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.book.event"
    })
  }, /*#__PURE__*/React.createElement(BookEvent, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.our.path"
    })
  }, /*#__PURE__*/React.createElement(OurPath, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.ti_serve_aiuto"
    })
  }, /*#__PURE__*/React.createElement(Faq, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.ti_serve_aiuto"
    }) + "/category/:id/:param?",
    component: FaqCategory
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.ti_serve_aiuto"
    }) + "/detail/:id/:param?",
    component: FaqDetail
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.our.partners"
    }) + "/:id/:param?",
    component: ProduttoriDetail
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.restaurants"
    }) + "/:id/:param?",
    component: Stores
  }), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.myaccount"
    })
  }, /*#__PURE__*/React.createElement(MyAccount, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.login"
    })
  }, /*#__PURE__*/React.createElement(LoginPage, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.signup"
    })
  }, /*#__PURE__*/React.createElement(CreateAccountPage, {
    isPage: true
  })), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.data"
    })
  }, /*#__PURE__*/React.createElement(MyAccountData, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.reservations"
    })
  }, /*#__PURE__*/React.createElement(Reservations, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.orders"
    })
  }, /*#__PURE__*/React.createElement(Orders, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.convertTicket"
    })
  }, /*#__PURE__*/React.createElement(ConvertTicketPage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.blog"
    }) + "/category/:id/:param?",
    component: BlogCategory
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.blog"
    }) + "/detail/:id/:param?",
    component: BlogDetail
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/search-blog.html"
  }, /*#__PURE__*/React.createElement(SearchBlog, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.order"
    }),
    component: OrderPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "".concat(formatMessage({
      id: "url.key.order.from.restaurant"
    }), "/:restaurantId"),
    component: OrderPageFromRestaurant
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/checkCookies"
  }, /*#__PURE__*/React.createElement(CookieCheck, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.loyalty.history"
    })
  }, /*#__PURE__*/React.createElement(PuntiSeeds, null)), IS_COUPON_ACTIVE ? /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.coupon"
    })
  }, /*#__PURE__*/React.createElement(CouponPage, null)) : null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.events"
    }) + "/:id/:param?",
    component: EventDetails
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/customer/account/createPassword",
    component: PwdRecovery
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.events.reservation"
    }),
    component: EventsReservation
  }), isOrderActive && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.pay"
    }),
    component: TablePage
  }), isOrderActive && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/payment/:paymentId",
    component: ReceiptRoot
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/kiosklogin/:connectionId/:challenge",
    component: KioskLoginRoot
  }), /*#__PURE__*/React.createElement(Route, {
    component: MagentoRoute
  })));
  return routeStructure;
};
export default Routes;